import { paymentApi } from "@/services/payment.api";
import { PaymentSessionContext } from "@/types/payment";

/**
 * MED-1321: finds the open (resumable) payment of the facility's pending
 * invoice, as a payment context. Used when this tab has no stored context
 * (e.g. PayDunya's return URL opened in a new tab). Resolves null when there
 * is nothing to resume or the lookup fails.
 */
export async function findOpenPaymentContext(
  facilityId: number | string | null | undefined
): Promise<PaymentSessionContext | null> {
  if (!facilityId) return null;
  try {
    const invoice = await paymentApi.getPendingInvoice(Number(facilityId));
    if (!invoice) return null;
    const intent = await paymentApi.getOpenInvoicePayment(invoice.id);
    if (!intent) return null;
    return { type: "facility", invoiceId: invoice.id, paymentIntentId: intent.paymentIntentId };
  } catch {
    return null;
  }
}
